import { infiniteQueryOptions } from '@tanstack/react-query'
import getBalance from '../api/get-balance'
import createPlaceholderBalanceResponse from '../lib/create-placeholder-balance-response'

export const getBalanceQueryKey = (userId: string) => ['balance', userId]

export const getBalanceQueryOptions = (userId: string) =>
  infiniteQueryOptions({
    queryKey: getBalanceQueryKey(userId),
    queryFn: async ({ pageParam }) => {
      const balance = await getBalance(userId, pageParam)
      if (!balance) {
        const placeholderResponse = createPlaceholderBalanceResponse()
        return placeholderResponse.data.balanceByUserId!
      }

      return balance
    },
    staleTime: 10_000,
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => lastPage?.transactions.pageInfo.endCursor ?? null,
  })
